import { memo } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Download, Printer } from 'react-bootstrap-icons';
import { CSVLink } from 'react-csv';
import { SCHEDULE_CSV_HEADERS } from './scheduleExportCsv';
import { ScheduleToolbarButton } from './ScheduleToolbarButton';
import type { useScheduleExport } from './useScheduleExport';

export type ScheduleExportApi = ReturnType<typeof useScheduleExport>;

type ScheduleExportActionsProps = {
  variant: 'desktop' | 'mobile';
  exportApi: ScheduleExportApi;
};

export const ScheduleExportActions = memo(function ScheduleExportActions({
  variant,
  exportApi,
}: ScheduleExportActionsProps) {
  const {
    prefix,
    t,
    setPrintModalOpen,
    csvRows,
    csvFilename,
    exportDisabled,
  } = exportApi;

  if (variant === 'mobile') {
    return (
      <>
        <Dropdown.Item
          disabled={exportDisabled}
          onClick={() => !exportDisabled && setPrintModalOpen(true)}
        >
          {t(prefix + 'schedulePrint')}
        </Dropdown.Item>
        {exportDisabled ? (
          <Dropdown.Item disabled>{t(prefix + 'scheduleExportCsv')}</Dropdown.Item>
        ) : (
          <Dropdown.Item as="div" className="p-0">
            <CSVLink
              data={csvRows}
              headers={SCHEDULE_CSV_HEADERS}
              filename={csvFilename}
              className="dropdown-item"
              target="_blank"
            >
              {t(prefix + 'scheduleExportCsv')}
            </CSVLink>
          </Dropdown.Item>
        )}
      </>
    );
  }

  return (
    <>
      <ScheduleToolbarButton
        disabled={exportDisabled}
        aria-label={t(prefix + 'schedulePrint')}
        title={t(prefix + 'schedulePrintTooltip')}
        onClick={() => setPrintModalOpen(true)}
        icon={<Printer size={18} aria-hidden />}
        labelClassName="d-none d-lg-inline small"
      >
        {t(prefix + 'schedulePrint')}
      </ScheduleToolbarButton>
      {exportDisabled ? (
        <ScheduleToolbarButton
          disabled
          aria-label={t(prefix + 'scheduleExportCsv')}
          title={t(prefix + 'scheduleExportCsvTooltip')}
          icon={<Download size={18} aria-hidden />}
          labelClassName="d-none d-lg-inline small"
        >
          {t(prefix + 'scheduleExportCsv')}
        </ScheduleToolbarButton>
      ) : (
        <CSVLink
          data={csvRows}
          headers={SCHEDULE_CSV_HEADERS}
          filename={csvFilename}
          className="btn btn-sm btn-outline-secondary schedule-toolbar__btn d-inline-flex align-items-center gap-1 text-decoration-none text-body"
          target="_blank"
          title={t(prefix + 'scheduleExportCsvTooltip')}
          aria-label={t(prefix + 'scheduleExportCsv')}
        >
          <Download size={18} aria-hidden />
          <span className="d-none d-lg-inline small">{t(prefix + 'scheduleExportCsv')}</span>
        </CSVLink>
      )}
    </>
  );
});
